export const SITE_TITLE = {
  DEFAULT: 'Rymax Shopping Site',
  MOBILE: 'Rymax Shopping Site',
};
